import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService, AdministrationService } from '../../../services';
import { Location } from '@angular/common';
import { User } from '../../../models';
import { Utils } from '../../../utils';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-users-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css']
})

export class UsersViewComponent implements OnInit, OnDestroy {

    sub: any;
    id: any;
    block: boolean;
    currentUser: User;

    constructor(
        private utils: Utils,
        private messageService: MessageService,
        private router: Router,
        private route: ActivatedRoute,
        private administrationService: AdministrationService,
        private location: Location
    ) { }

    ngOnInit() {
        this.block = false;
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];

            this.currentUser = new User();

            if (this.id == null || this.id === 'new') {
                this.currentUser.active = true;
                return;
            }

            this.administrationService.getById(this.id).subscribe(user => this.currentUser = user);
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    save(): void {
        let valid = true;
        if (!this.currentUser.companyName) {
            this.messageService.add({ severity: 'warn', summary: 'Nazwa firmy najemcy jest wymagana' });
            valid = false;
        }
        if (!this.currentUser.name) {
            this.messageService.add({ severity: 'warn', summary: 'Imię i nazwisko są wymagane' });
            valid = false;
        }
        if (!this.currentUser.email) {
            this.messageService.add({ severity: 'warn', summary: 'E-mail jest wymagany' });
            valid = false;
        }
        if (!this.currentUser.login) {
            this.messageService.add({ severity: 'warn', summary: 'Login jest wymagany' });
            valid = false;
        }
        if (!valid) {
            return;
        }
        this.block = true;
        this.administrationService.createOrUpdate(this.currentUser)
            .subscribe(
                () => {
                    this.block = false;
                    this.messageService.add({ severity: 'success', summary: 'Zapisano dane użytkownika' });
                    this.router.navigate(['/users']);
                },
                error => {
                    this.block = false;
                    console.log(this.utils.handleError(error));
                    this.messageService.add({ severity: 'error', summary: 'Nie zapisano danych użytkownika', detail: this.utils.handleError(error) });
                }
            );
    }

    resetPassword(): void {
        this.block = true;
        this.administrationService.resetUserPassword(this.currentUser.login)
            .subscribe(
                () => {
                    this.block = false;
                    this.messageService.add({ severity: 'success', summary: 'Zresetowano hasło użytkownika', detail: 'Został wysłany e-mail z hasłem do użytkownika.' });
                    console.log('Wysłano e-mail do uzytkownika');
                }, error => {
                    this.block = false;
                    console.log(this.utils.handleError(error));
                    this.messageService.add({ severity: 'error', summary: 'Błąd podczas przywracana hasła', detail: this.utils.handleError(error) });
                }
            );
    }

    cancel(): void {
        this.location.back();
    }
}
